// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".step-pill[data-v-5c9bd58a] {\n  width: 28px;\n  height: 28px;\n}", ""]);
// Exports
module.exports = exports;
